import { createRoot } from 'react-dom/client';
import Body from 'Body';

const domNode = document.getElementById('wishlist-container');
if (domNode) {
    const root = createRoot(domNode);
    root.render(<Body />);
}
